module.exports = __webpack_public_path__ + "static/team-2d371e03ffc93b77f3e1d3e5be045b74.png";